import { createListButtonStyles as styles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";

styles.createListButton = {
    variant: "primary",
};
